import React from "react";
import { COLORS } from "./animauxTagsData";
import { IconShape } from "./icons";

export default function TagPreview({ model, color, font, petName, phone, addr, extra, view, icon }) {
  const selected = COLORS.find(c => c.name === color) || COLORS[2];
  const isPaw = model === "patas";
  const isCat = model === "gatos";
  const textFill = selected.name === "negro" ? "#ffffff" : "#111111";
  const hasIcon = icon && icon !== "none";

  // When an icon is present we shrink the text a touch and shift it down a few px
  const baseLabel = (petName || "ANIMAUX TAGS").toUpperCase();
  const longText = baseLabel.length > 10;

  return (
    <div className={`tag-stage flip-stage ${view === "back" ? "is-flipped" : ""}`}>
      <div className="flip-inner">
        <div className="flip-face flip-front">
          <svg viewBox="0 0 520 360" className="tag-svg" role="img" aria-label="Pet tag preview">
            <defs>
              <filter id="shadow" x="-30%" y="-30%" width="160%" height="160%">
                <feDropShadow dx="0" dy="18" stdDeviation="18" floodColor="#000" floodOpacity="0.45" />
              </filter>
              <linearGradient id="shine" x1="0" x2="1">
                <stop offset="0%" stopColor="rgba(255,255,255,.18)" />
                <stop offset="100%" stopColor="rgba(255,255,255,0)" />
              </linearGradient>
            </defs>

            {isCat ? (
              <g filter="url(#shadow)">
                <circle cx="260" cy="190" r="118" fill={selected.hex} />
                <circle cx="260" cy="190" r="118" fill="url(#shine)" />
                <circle cx="260" cy="190" r="123" fill="none" stroke="#d7d7d7" strokeWidth="10" opacity=".9" />
                <path
                  d="M195 185 L212 130 L247 165 Q260 158 273 165 L308 130 L325 185 Q335 215 315 238 Q292 265 260 265 Q228 265 205 238 Q185 215 195 185Z"
                  fill="none" stroke="#efefef" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" opacity=".95"
                />
                <circle cx="238" cy="205" r="5" fill="#efefef" />
                <circle cx="282" cy="205" r="5" fill="#efefef" />
                <path d="M260 218 L252 230 H268 Z" fill="#efefef" opacity=".95" />
              </g>
            ) : isPaw ? (
              <g filter="url(#shadow)">
                <circle cx="260" cy="210" r="104" fill={selected.hex} />
                <circle cx="185" cy="112" r="34" fill={selected.hex} />
                <circle cx="238" cy="88" r="36" fill={selected.hex} />
                <circle cx="292" cy="88" r="36" fill={selected.hex} />
                <circle cx="345" cy="112" r="34" fill={selected.hex} />
                <circle cx="260" cy="210" r="104" fill="url(#shine)" />
              </g>
            ) : (
              <g filter="url(#shadow)">
                <path
                  d="M151 131c-26-25-72-7-72 31 0 20 13 35 29 42-16 7-29 22-29 42 0 38 46 56 72 31h218c26 25 72 7 72-31 0-20-13-35-29-42 16-7 29-22 29-42 0-38-46-56-72-31H151z"
                  fill={selected.hex}
                />
                <path
                  d="M151 131c-26-25-72-7-72 31 0 20 13 35 29 42-16 7-29 22-29 42 0 38 46 56 72 31h218c26 25 72 7 72-31 0-20-13-35-29-42 16-7 29-22 29-42 0-38-46-56-72-31H151z"
                  fill="url(#shine)"
                />
              </g>
            )}

            <circle cx="260" cy={isCat ? 95 : isPaw ? 150 : 160} r="12" fill="#0A0A0A" opacity=".35" />

            {/* Icon (front only) */}
            {hasIcon && (
              <g
                transform={`translate(${isCat ? 244 : 244}, ${isCat ? 145 : isPaw ? 175 : 170}) scale(${isCat ? 1.4 : isPaw ? 1.4 : 1.5})`}
              >
                <IconShape kind={icon} color={textFill} strokeWidth={2.6} />
              </g>
            )}

            {isCat ? (
              <text
                x="260"
                y={hasIcon ? 252 : 240}
                textAnchor="middle"
                dominantBaseline="middle"
                fill={textFill}
                fontFamily={font}
                fontWeight="900"
                fontSize={longText ? 18 : baseLabel.length > 8 ? 22 : 28}
                letterSpacing="1.2"
                textLength={longText ? "176" : "188"}
                lengthAdjust="spacingAndGlyphs"
              >
                {baseLabel}
              </text>
            ) : (
              <text
                x="260"
                y={hasIcon ? (isPaw ? 248 : 240) : (isPaw ? 235 : 222)}
                textAnchor="middle"
                dominantBaseline="middle"
                fill={textFill}
                fontFamily={font}
                fontWeight="900"
                fontSize={
                  isPaw
                    ? (longText ? 22 : 30)
                    : (longText ? (hasIcon ? 26 : 30) : baseLabel.length > 8 ? 36 : (hasIcon ? 46 : 54))
                }
                letterSpacing={isPaw ? "0.5" : "1.5"}
                textLength={isPaw ? "210" : "285"}
                lengthAdjust="spacingAndGlyphs"
              >
                {baseLabel}
              </text>
            )}
          </svg>
        </div>

        {/* BACK */}
        <div className="flip-face flip-back">
          <svg viewBox="0 0 520 360" className="tag-svg" role="img" aria-label="Pet tag back preview">
            <defs>
              <filter id="shadow2" x="-30%" y="-30%" width="160%" height="160%">
                <feDropShadow dx="0" dy="18" stdDeviation="18" floodColor="#000" floodOpacity="0.45" />
              </filter>
            </defs>
            {isCat ? (
              <g filter="url(#shadow2)">
                <circle cx="260" cy="190" r="118" fill={selected.hex} />
                <circle cx="260" cy="190" r="123" fill="none" stroke="#d7d7d7" strokeWidth="10" opacity=".9" />
              </g>
            ) : isPaw ? (
              <g filter="url(#shadow2)">
                <circle cx="260" cy="210" r="104" fill={selected.hex} />
                <circle cx="185" cy="112" r="34" fill={selected.hex} />
                <circle cx="238" cy="88" r="36" fill={selected.hex} />
                <circle cx="292" cy="88" r="36" fill={selected.hex} />
                <circle cx="345" cy="112" r="34" fill={selected.hex} />
              </g>
            ) : (
              <g filter="url(#shadow2)">
                <path
                  d="M151 131c-26-25-72-7-72 31 0 20 13 35 29 42-16 7-29 22-29 42 0 38 46 56 72 31h218c26 25 72 7 72-31 0-20-13-35-29-42 16-7 29-22 29-42 0-38-46-56-72-31H151z"
                  fill={selected.hex}
                />
              </g>
            )}
            <circle cx="260" cy={isCat ? 95 : isPaw ? 150 : 160} r="12" fill="#0A0A0A" opacity=".35" />

            <g fill={textFill} fontFamily="'Montserrat', sans-serif" fontWeight="800" fontSize="24" textAnchor="middle">
              <text x="260" y="205">{phone || "514-000-0000"}</text>
              <text x="260" y="238">{addr || ""}</text>
              <text x="260" y="271">{extra || "INFO EXTRA"}</text>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}
